// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__RaWWv","icon":"LogoutButton_icon__D2ieM"};